
export default {
  name: 'owner-mock'
};
